import { data } from 'react-router-dom';
import api from '../instance/axios_instance.ts';
import { CustomerInterface, CustomerStatusInterface } from '../interface/customerInterface.ts';

export const UpdateCustomerApi = async (data: CustomerInterface): Promise<CustomerInterface> => {

    try {
        const response = await api.put<CustomerInterface>('/update_customer', data);
        return response.data;
    }
    catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error updating customer');
    }
};
export const UpdateCustomerStatusApi = async (data: CustomerStatusInterface) => {
    try {
        const response = await api.put<CustomerStatusInterface>('/update_customer_status', data);
        return response.data;
    }
    catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error updating customer status');
    }
};